

import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    {
        const PAGE = document.querySelector('.ProductCategoryPage')
        if(!PAGE) return

        const header = PAGE.querySelector('.search-header .wave-content')
        const wave = PAGE.querySelector('.search-header .wave')
        const background = PAGE.querySelector('.search-header')
        const items = PAGE.querySelectorAll('.product-card')

        const timeline = gsap.timeline({
            ease: 'power2.inOut'
        })

        timeline.to(header, { translateY: 0, opacity: 1 })
            .to(wave, { translateY: 0 }, "<")
            //.to(background, { 'background-size': '100%' }, "<")
            .to(items, {
                stagger: {
                    each: 0.05,
                    from: "edges",
                },
                opacity: 1
            }, "<")
    }
}
